import { Router } from "@angular/router";

import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";

import { User } from "./user.model";

@Injectable()
export class AuthService {
  token: string;
  userdata: User;
  private url = "http://honadon.uz/";

  constructor(
    private router: Router,
    private http: HttpClient,
  ) {}

  
  signUp(data) {
    var headers = new HttpHeaders();
    const params = new HttpParams();
    headers.append("Content-Type", "application/json");

    const options = {
      params,
      reportProgress: true,
      headers: headers
    };

    let h = JSON.stringify(data);
    h = JSON.parse(h);
    console.log("899" + h);
    return this.http.post(this.url + "api/Auth/Register", h, options);
  }
  signOut() {
    localStorage.removeItem("token");
     }
  signin(data) {
    let h = JSON.stringify(data);
    
    console.log("signin:"+h);
        h = JSON.parse(h);
        console.log(h);
        return this.http.post(this.url + "api/Auth/Login", h);
      
  }
  
  doFacebookLogin() {
  
  }

  doTwitterLogin() {
  
  }

  doGoogleLogin() {
  
  }

  doRegister(value) {
   
  }

  doLogin(value) {
   
  }

  signinUser(email: string, password: string) {
   
  }

  logout() {
    this.token = null;
  }



  isAuthenticated() {
    this.token=localStorage.getItem('token');
    return this.token != null;
  }

  storeToken(token: string) {
    localStorage.setItem("token", token);
  }
  getToken() {
    return localStorage.getItem("token");
  }
  removeToken(){
    return localStorage.removeItem("token");
  }
}
